// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__35lNY","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__nPNhM"};